export enum SortOrder {
    Asc,
    Desc
}
